/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Realtime Schema Projection
 * Frontend-only aliases for realtime payload validation.
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {RealtimeResourceChange} from "./realtimeResourceChange.zod";

export const RepresentativeRealtimeChange = RealtimeResourceChange.and(
  zod.object({
    resource: zod.enum(["sales.representatives"]),
    resourceId: zod.uuid(),
    change: zod.enum(["CREATED", "UPDATED", "DELETED", "RESTORED"]),
  }),
);

export type RepresentativeRealtimeChange = zod.input<typeof RepresentativeRealtimeChange>;
export type RepresentativeRealtimeChangeOutput = zod.output<typeof RepresentativeRealtimeChange>;
